// ============================================================================
// Record-activity latest-value consumer registry
// ============================================================================
//
// A list may need the most recent Activity timestamp for each visible record
// without becoming the owner of the complete record Activity stream. This is a
// shared component-side capability, not a route resource: the small registry
// below records every automatic list mount that asks for it, while leaving the
// route catalog, 77-surface manifest, and boot release ledger untouched.
// ============================================================================

/** The scoped Query resource for a record's newest Activity timestamp. */
export const RECORD_ACTIVITY_LATEST_RESOURCE = Object.freeze({
  LATEST: 'shared.record-activity.latest',
});

export type RecordActivityLatestConsumer = {
  readonly source: string;
  readonly surface: string;
  readonly entityType: string;
  /** The source list whose sorted, unique IDs select the bounded record fanout. */
  readonly recordIdContract: string;
  /** The list payload identity that asks already-mounted records to refresh. */
  readonly listRefreshContract: string;
  readonly limit: number;
  readonly activation: string;
};

// One entry per automatic `useRecordActivityLatest` mount. `surface` records
// reachability only; it does not claim that this shared sidecar owns the
// surface's route data or that the surface can bypass legacy boot.
export const RECORD_ACTIVITY_LATEST_CONSUMERS: readonly RecordActivityLatestConsumer[] = Object.freeze([
  Object.freeze({
    source: 'src/cattle/CattleHerdsView.tsx',
    surface: 'cattle.herds.index',
    entityType: 'cattle.animal',
    recordIdContract: 'sorted unique cattle[].id',
    listRefreshContract: 'herds.data identity refreshes all current record IDs',
    limit: 1,
    activation: 'Last Activity sort or visible Last Activity column',
  }),
]);
